export const byField = field => (firstObject, secondObject) => {
  if (firstObject[field] < secondObject[field]) {
    return -1;
  }
  if (firstObject[field] > secondObject[field]) {
    return 1;
  }
  return 0;
};

export const byFieldUpperCase = field => (firstObject, secondObject) => {
  if (firstObject[field].toUpperCase() < secondObject[field].toUpperCase()) {
    return -1;
  }
  if (firstObject[field].toUpperCase() > secondObject[field].toUpperCase()) {
    return 1;
  }
  return 0;
};
